// Unregister any existing service workers
// This ensures users who had the old service worker get it removed
export default function unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister();
            console.log('Service worker unregistered - fresh content will be loaded on next visit');
        }).catch(error => {
            console.log('Service worker unregistration failed:', error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/unregisterServiceWorker.js